/* eslint-disable indent */

const isNewLogicAddPax = Odigeo.AB.getNewLogicAddPax === 3 && Odigeo.Utils.isMobile();

    Odigeo.defineWidget('passengers_update', Odigeo.Widget.extend({
        modelClass: require('../modules/models/passengers_update_manager.js'),
        viewClass: Odigeo.View.extend({
            uploadingDialog: null,
            selectors: {
                addpaxTemplate: '.updatingPax_template',
                addpaxAction: '.details_change_pax_button',
                buttonContainer: '.add_pax_container',
                addpaxButttonWrapper: '.addpax_wrapper',
            },

            events: {
                'tap @addpaxAction': 'onAddpaxAction',
            },

            init() {
                if (!this.widget.model.isSearchData()) {
                    this.$cachedSelectors.addpaxButttonWrapper.prop('disabled', true);
                }
            },

            onAddpaxAction(evt) {
                evt.stopPropagation();
                this.widget.addPax(evt);
            },

            showAddPaxButton() {
                this.$cachedSelectors.buttonContainer.removeClass('odf-hidden');
            },

            showLoadingMessage() {
                var template = this.$el.find(this.$cachedSelectors.addpaxTemplate);
                this.uploadingDialog = Odigeo.UIElements.showUploadingResultsInfo(template);
                this.uploadingDialog.uploading();
            },

            showUpdatingOk() {
                this.uploadingDialog.confirm();
            },

            redirectToResultWithNewPassengerNumbers() {
                this.showLoadingMessage();
                this.model.redirectToResultPage();
            },
        }),


        addPax(evt) {
            const dataTackLabel = evt ? evt.target.getAttribute('data-track-label') : '';
            const action = Odigeo._.get(evt, 'currentTarget.dataset.action');
            this.model.addPax({action: action, actionFrom: dataTackLabel});
            if (isNewLogicAddPax) {
                this.view.redirectToResultWithNewPassengerNumbers();
            } else {
                this.model.refreshData();
            }
        },

        showAddPaxButton() {
            this.view.showAddPaxButton();
        },

        storeItinerarySearchRequestData() {
            const itinerarySearchRequestData = this.model.getItinerarySearchRequestData();
            Odigeo.Session.set('recoverSessionItinerarySearchRequestData', JSON.stringify(itinerarySearchRequestData));
        },

    }));
